import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiVisa, BasicApiResponseModel } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { OCRScannedDocService } from './ocr-scanned-doc.service';

// https://api.akaun.dev/core2/platform/dm/tenants/tenant-users

@Injectable({
  providedIn: 'root'
})

export class OCRUploadFileService extends BaseApiTemplateService<any> {

  static readonly OCR_SCANNED_DOCS_UPLOAD_FILE = OCRScannedDocService.OCR_SCANNED_DOCS_SUB_PATH +  'upload-file/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + OCRUploadFileService.OCR_SCANNED_DOCS_UPLOAD_FILE + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + OCRUploadFileService.OCR_SCANNED_DOCS_UPLOAD_FILE + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  OCRUploadFileService.OCR_SCANNED_DOCS_UPLOAD_FILE + BaseApiTemplateService.BACKOFFICE_EP;

    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX +  OCRUploadFileService.OCR_SCANNED_DOCS_UPLOAD_FILE + BaseApiTemplateService.LOGIN_ENTITY_EP;
  }

  public postWithAttachmentsLogin(dtoObject: FormData, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url ? 
      visa.api_domain_url + this.endpoint_path_login_url 
      : this.apiUrl;
      
    return this.httpClient.post<BasicApiResponseModel<any>>(
      loginApiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}

